// Door styles and series data
import roller from "../Component/images/roller.svg";
import sectional from "../Component/images/sectional.svg";
import native from "../Component/images/native_icon.svg";
import master from "../Component/images/master_icon.svg";
import hampton from "../Component/images/hampton_icon.svg";
import caeser from "../Component/images/caesar_icon.svg";
import baron from "../Component/images/baron_icon.svg";
import sultan from "../Component/images/sultan_icon.svg";
import royall from "../Component/images/royal_l_icon.svg";
import royalr from "../Component/images/royal_r_icon.svg";
import regent from "../Component/images/regent_icon.svg";
import centerbury from "../Component/images/Centerbury.png";
import centerburyOxford from "../Component/images/caenterbury-img-oxford.png";
import countryOxford from "../Component/images/county-img-oxford.png";
import country from "../Component/images/Country.png";
import cascade from "../Component/images/cascade.png";
import sunset from "../Component/images/sunset.png";
import sunburst from "../Component/images/sunburst.png";
import traditional from "../Component/images/traditional.png";
import waterton from "../Component/images/waterton.png";
import compositeimg from "../Component/images/composite.svg";
import miniorb from "../Component/images/mini_orb.svg";
import honeycomb from "../Component/images/honeycomb.svg";
import aluminium from "../Component/images/aluminium.svg";

export const DOOR_STYLES = [
  { id: 1, name: "roller", img: roller },
  { id: 2, name: "sectional", img: sectional },
];

export const DOOR_SERIES = [
  { id: 1, name: "Essentials", img: sectional },
  { id: 2, name: "Native", img: native },
  { id: 3, name: "Selections Series", img: master },
];

export const ESSENTIAL_DOORS = [
  { id: 1, name: "Madison", img: native },
  { id: 2, name: "Tuscan", img: native },
  { id: 3, name: "Hampton", img: hampton },
  { id: 4, name: "Oxford", img: sectional },
];

export const NATIVE_DOORS = [
   { id: 1, name: "Madison", img: native },
  { id: 2, name: "Tuscan", img: native },
  { id: 3, name: "Hampton", img: hampton },
  { id: 4, name: "Oxford", img: sectional },
];

export const PANEL_STYLES = [
  { id: 1, name: "Alumicomp", img: master },
  // { id: 2, name: "SolidSheet", img: master },
];

export const ALUMICOMP_DESIGNS = [
  { id: 1, name: "Sovereign", img: master },
  { id: 2, name: "Caesar", img: caeser },
  { id: 3, name: "Sultan", img: sultan },
  { id: 4, name: "Baron", img: baron },
  { id: 5, name: "Royal (L)", img: royall },
  { id: 6, name: "Royal (R)", img: royalr },
];

export const SOLID_SHEET_DESIGNS = [
  { id: 1, name: "Sovereign", img: master },
  { id: 2, name: "Caesar", img: caeser },
  { id: 3, name: "Sultan", img: sultan },
  { id: 4, name: "Baron", img: baron },
  { id: 5, name: "Royal (L)", img: royall },
  { id: 6, name: "Royal (R)", img: royalr },
  { id: 7, name: "Regent", img: regent },
];


export const COLOURBOND_COLORS = [
  { id: 1, name: "Manor Red", bgcolor: "#5e1d0e", trademark: "®" },
  { id: 2, name: "Pale Eucalypt", bgcolor: "#7c846a", trademark: "®" },
  { id: 3, name: "Cottage Green", bgcolor: "#304c3c", trademark: "®" },
  { id: 4, name: "Deep Ocean", bgcolor: "#364152", trademark: "®" },
  { id: 5, name: "Ironstone", bgcolor: "#3e434c", trademark: "®" },
  { id: 6, name: "Night Sky", bgcolor: "#111111", trademark: "®" },
  { id: 7, name: "Monument", bgcolor: "#323233", trademark: "®" },
  { id: 8, name: "Woodland Grey", bgcolor: "#4b4c46", trademark: "®" },
  { id: 9, name: "Basalt", bgcolor: "#6d6c6e", trademark: "®" },
  { id: 10, name: "Wallaby", bgcolor: "#7f7c78", trademark: "®" },
  { id: 11, name: "Jasper", bgcolor: "#6c6153", trademark: "®" },
  { id: 12, name: "Gully", bgcolor: "#857e73", trademark: "®" },
  { id: 13, name: "Windspray", bgcolor: "#888b8a", trademark: "®" },
  { id: 14, name: "Bluegum", bgcolor: "#969799", trademark: "®" },
  { id: 15, name: "Paperbark", bgcolor: "#cabfa4", trademark: "®" },
  { id: 16, name: "Dune", bgcolor: "#b1ada3", trademark: "®" },
  { id: 17, name: "Southerly", bgcolor: "#d2d1cb", trademark: "®" },
  { id: 18, name: "Evening Haze", bgcolor: "#c5c2aa", trademark: "®" },
  { id: 19, name: "Surfmist", bgcolor: "#e4e2d5", trademark: "®" },
  { id: 20, name: "Dover White", bgcolor: "#f9fbf1", trademark: "™" },
  { id: 21, name: "Classic Cream", bgcolor: "#e9dcb8", trademark: "™" },
  { id: 22, name: "Shale Grey", bgcolor: "#bdbfba", trademark: "™" }
];


export const PLATINUM_COLORS = [
  { id: 1, name: "Zinc graphite", bgcolor: "#3f3f3b" },
  { id: 2, name: "Silver Quartz", bgcolor: "#b1b1b1" },
  { id: 3, name: "Midnight Matt", bgcolor: "#1c1a1b" },
];

export const NATIVE_COLORS = [
  { id: 1, name: "Dark Oak", bgcolor: "#632b0a" },
  { id: 2, name: "Classic Cedar", bgcolor: "#723905" },
  { id: 3, name: "Ashwood", bgcolor: "#62350c" },
  { id: 4, name: "Walnut", bgcolor: "#3a0d0d" },
  { id: 5, name: "Weathered Teak", bgcolor: "#BCAC9C" },
  { id: 6, name: "Grey Oak", bgcolor: "#666666" },
];

export const COMPOSITE_COLORS = [
  { id: 1, name: "Silver", bgcolor: "#aaaaaa" },
  { id: 2, name: "Almost Black", bgcolor: "#181818" },
  { id: 3, name: "Metallic-grey", bgcolor: "#a5a098" },
  { id: 4, name: "White", bgcolor: "#eeeeee" },
];

export const OXFORD_WINDOWS = [
  { id: 1, name: "Centerbury", img: centerburyOxford },
  { id: 2, name: "County", img: countryOxford },
  { id: 3, name: "Cascade", img: cascade },
  { id: 4, name: "Sunset", img: sunset },
  { id: 5, name: "Sunburst", img: sunburst },
  { id: 6, name: "Traditional", img: traditional },
  { id: 7, name: "Waterton", img: waterton },
];

export const HAMPTON_WINDOWS = [
  { id: 1, name: "Centerbury", img: centerbury },
  { id: 2, name: "County", img: country },
  { id: 3, name: "Cascade", img: cascade },
  { id: 4, name: "Horizon", img: sunset },
  { id: 5, name: "Sunburst", img: sunburst },
  { id: 6, name: "Traditional", img: traditional },
  { id: 7, name: "Waterton", img: waterton },
];

export const MATERIALS = [
  { id: 1, name: "Composite", img: compositeimg }
];

export const SOLID_MATERIALS = [
  { id: 1, name: "Composite", img: compositeimg },
  { id: 2, name: "Mini Orb", img: miniorb },
  { id: 3, name: "Honeycomb", img: honeycomb },
  { id: 4, name: "Polycarbonate", img: compositeimg },
  { id: 5, name: "Aluminium", img: aluminium },
];

export const DEFAULT_POINTS = {
  PLATINUM: [
    { x: 405, y: 313 },
    { x: 660, y: 316 },
    { x: 661, y: 426 },
    { x: 403, y: 422 },
  ],
  ROLLER_DOOR: [
    { x: 451, y: 315 },
    { x: 781, y: 316 },
    { x: 780, y: 470 },
    { x: 452, y: 467 },
  ],
  SECTION_HAMPTON_WINDSPRAY: [
    { x: 382, y: 262 },
    { x: 713, y: 264 },
    { x: 720, y: 480 },
    { x: 381, y: 477 },
  ],
  SECTIONAL_DOOR: [
    { x: 242, y: 343 },
    { x: 451, y: 346 },
    { x: 450, y: 468 },
    { x: 242, y: 466 },
  ],
  SECTIONAL_MADISON_MONUMENT: [
    { x: 339, y: 385 },
    { x: 539, y: 370 },
    { x: 537, y: 505 },
    { x: 340, y: 486 },
  ],
  SECTIONAL_MADISON_NIGHTSKY: [
    { x: 388, y: 243 },
    { x: 704, y: 252 },
    { x: 699, y: 482 },
    { x: 386, y: 485 },
  ],
  SECTIONAL_TUSCAN_DOVER: [
    { x: 412, y: 259 },
    { x: 661, y: 261 },
    { x: 659, y: 378 },
    { x: 409, y: 381 },
  ],
  SELECTIONS: [
    { x: 396, y: 331 },
    { x: 613, y: 329 },
    { x: 614, y: 435 },
    { x: 395, y: 437 },
  ],
  DEFAULT: [
    { x: 250, y: 250 },
    { x: 550, y: 250 },
    { x: 550, y: 400 },
    { x: 250, y: 400 },
  ],
};

export const INITIAL_DOOR_DIMENSIONS = {
  WIDTH: 225,
  HEIGHT: 100,
};

export const CANVAS_DIMENSIONS = {
  WIDTH: 840,
  HEIGHT: 580,
};